import React, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import PriceItem from './PriceItem';
import ClearButton from '../../../shared/components/Prices/ClearButton';
import CurrencyIcon from '../../../shared/components/Icons/Currency';
import Scrollable from '../../../shared/components/Scrollable';
import usePrices from '../../../hooks/usePrices';
import Tooltip from '../Tooltip';
import { isMobile } from '../../../helpers/device';
import { getBoundingClientRect } from '../../../helpers/coordinates';

const Prices = ({ isFullscreen, schemeMode }) => {
  const { pricesPreview, isPeriodical, withoutRendering } = usePrices();
  const [tooltipData, setTooltipData] = useState<{ left: string; content: string } | null>(null);

  const containerRef = useRef<HTMLDivElement>();

  const showTooltip = (tooltipData) => {
    let closeTimer;

    if (containerRef.current) {
      tooltipData.left -= getBoundingClientRect(containerRef.current).left;
      setTooltipData(tooltipData);

      if (closeTimer) {
        clearTimeout(closeTimer);
      }
    }

    if (isMobile()) {
      closeTimer = setTimeout(hideTooltip, 2000);
    }
  };

  const hideTooltip = () => setTooltipData(null);

  if (withoutRendering) return null;

  return (
    <Container
      schemeMode={schemeMode}
      isFullscreen={isFullscreen}
      isPeriodical={isPeriodical}
      ref={containerRef}
    >
      {tooltipData && (
        <Tooltip
          style={{ left: tooltipData.left }}
          message={[`${tooltipData.content} `, <CurrencyIcon fill="#fff" width={8} height={10} />]}
        />
      )}
      <Scrollable>
        <ListWrapper>
          <List>
            {pricesPreview.map((price) => (
              <PriceItem
                key={price.value}
                price={price}
                mouseEnterHandler={showTooltip}
                mouseLeaveHandler={hideTooltip}
              />
            ))}
          </List>
          <ClearButton />
        </ListWrapper>
      </Scrollable>
    </Container>
  );
};

const Container = styled.div<any>`
  position: relative;
  width: 100%;
  display: ${({ schemeMode }) => !schemeMode && 'none'};
  max-width: 80%;
  text-align: center;
  margin: 18px auto 0;

  ${({ theme: { isMobile } }) =>
    isMobile &&
    css`
      text-align: initial;
      max-width: 100%;
    `}
`;

const ListWrapper = styled.div<any>`
  padding: 2px 20px;
  margin: 0 auto;
  z-index: 10;

  ${({ theme: { isMobile } }) =>
    !isMobile &&
    css`
      display: inline-block;
      padding: 6px 20px;
      margin: 0 auto;
    `}
`;

const List = styled.ul<any>`
  display: ${({ theme: { isMobile } }) => (isMobile ? 'flex' : 'inline')};
  vertical-align: middle;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export default Prices;
